import MainHeader from "../../layouts/MainHeader";
import BorderLeftBox from "../../components/boxes/BorderLeftBox";
import SecondaryCard from "../../components/cards/SecondaryCard";
import sustainableProductsPageData from "../../data/english/subpages/sustainable-products-page-data";
import Footer from "../../layouts/Footer";
import ScrollView from "../../components/ScrollView/ScrollView";
import CardThree from "../../components/cards/CardThree";

const SustainableProductPage = () => {
  return (
    <main className="page" id="main">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            title=""
            image={{
              src: require(`../../assets/images/backgrounds/sustainable-project.jpg`),
              alt: "Sustainable Product and Services",
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <h1 className="title-center">
              {sustainableProductsPageData.mainTitle}
            </h1>
          </div>
          <div className="wrapper-small">
            <ScrollView>
            {sustainableProductsPageData.sectionOne.map((item, index) => (
            <CardThree
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              icon={{
                src: require(`../../assets/icons/environment/${item.icon}`),
                alt: "",
              }}
            />
          ))}
            </ScrollView>
          </div>
          
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="wrapper-small">
            <BorderLeftBox
              title={sustainableProductsPageData.sectionTwo.borderBox.title}
              subtitle={
                sustainableProductsPageData.sectionTwo.borderBox.subtitle
              }
            />
            <p className="text-paragraph">
              {sustainableProductsPageData.sectionTwo.paragraphTwo}
            </p>
            <div className="table-wrapper">
              <table className="table-secondary">
                <thead>
                  <tr aria-hidden="true"></tr>
                  <tr>
                    <th>
                      {
                        sustainableProductsPageData.sectionTwo.tableOne
                          .headers[0]
                      }
                    </th>
                  </tr>
                </thead>
              </table>
              <p className="text-note">
                SAB’s green deposit allows customers to safely deposit their
                money towards green financing initiatives, with these client
                funds generating competitive returns for short to medium-term
                investments.
              </p>
              <table className="table-secondary">
                <tbody>
                  {sustainableProductsPageData.sectionTwo.tableOne.data.map(
                    (item, index) => (
                      <tr key={index}>
                        <td className="mnw-200">
                          <b>{item[0]}</b>
                        </td>
                        <td>{item[1]}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
            <BorderLeftBox
              title={sustainableProductsPageData.sectionTwo.borderBoxTwo.title}
              subtitle={
                sustainableProductsPageData.sectionTwo.borderBoxTwo.subtitle
              }
            />
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  );
};

export default SustainableProductPage;
